.group {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  margin: 0;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--surface);
}

.legend {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.option {
  position: relative;
  display: inline-flex;
}

.input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.label {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding-block: 6px;
  padding-inline: var(--space-3);
  border-radius: var(--radius-pill);
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: color var(--duration-fast) ease, background-color var(--duration-fast) ease;
}

.label:hover {
  color: var(--text);
}

/* Checked state is carried by the mark and the label weight as well as colour, so the
 * selection is never signalled by colour alone. */
.input:checked + .label {
  background: var(--accent-soft);
  color: var(--accent-strong);
  font-weight: 600;
}

.input:focus-visible + .label {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.glyph {
  inline-size: 13px;
  block-size: 13px;
  flex: none;
}
